<div class="flex flex-row items-center justify-start gap-1">
	@if (icon) {
	<mat-icon inline>{{ icon }}</mat-icon>
	} @if (labelKey) {
	<span>{{ labelKey | translate }}</span>
	} @else if (labelText) {
	<span>{{ labelText }}</span>
	}
</div>
@if (count != null && count > 0) {
<span class="filter-badge">{{ count }}</span>
} @else if (badgeWhenActive && active) {
<span class="filter-badge">1</span>
}
